import { Route } from '@angular/router';
import { featureAccessGuard } from '@iupics-util/guards/features-access.guard';
import { PortalAccessGuard } from '@iupics-util/guards/portal-access.guard';
import StudioComponent from './components/studio.component';
import { studioUnsavedChangesGuard } from './guards/studio-unsaved-changes.guard';
import { SDMenuItemsResolver, SDRecentItemsResolver } from './resolvers/studio-dashboard-data.resolver';
import { SDWindowDataResolver } from './resolvers/studio-window-data.resolver';
import { StudioApiService } from './services/studio-api.service';
import { StudioMessageService } from './services/studio-message.service';

const studioRoute: Route = {
  path: 'studio',
  canActivate: [PortalAccessGuard, featureAccessGuard],
  providers: [StudioMessageService, StudioApiService],
  component: StudioComponent,
  children: [
    {
      path: 'dashboard',
      resolve: {
        recentItems: SDRecentItemsResolver,
        menuItems: SDMenuItemsResolver,
      },
      loadComponent: () => import('@studio/components/dashboard/studio-dashboard.component'),
    },
    {
      path: 'new',
      canDeactivate: [studioUnsavedChangesGuard],
      loadComponent: () => import('@studio/components/editor/studio-editor.component'),
    },
    {
      path: ':id',
      canDeactivate: [studioUnsavedChangesGuard],
      resolve: {
        data: SDWindowDataResolver,
      },
      loadComponent: () => import('@studio/components/editor/studio-editor.component'),
    },
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
  ],
};

export default studioRoute;
